import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { PasoWizard } from '../../../../interface/wizard-informacion.types';
import { DatosSeccionWizardEventsService } from '../../../../services/datos-seccion-wizard-events.service';
import { ButtonControlService } from '../../../../services/button-control.service';
import {EvkExpedienteModel} from '../../../../../expediente/models/evk-expediente.model';
import {EvkSeccionModel} from '../../../../../expediente/models/evk-seccion.model';

@Component({
  selector: 'lib-solicitud-pago',
  templateUrl: './solicitud-pago.component.html',
  styleUrls: ['./solicitud-pago.component.css']
})
export class SolicitudPagoComponent implements OnInit {
  @Input()
  expediente: EvkExpedienteModel;
  @Input()
  config: PasoWizard;
  withouturl: boolean = false;
  url: string = "";
  originalUrl: string = "";
  @Output() readonly resultObject: EventEmitter<Object> = new EventEmitter<Object>();
  constructor(
    public datosSeccionWizard: DatosSeccionWizardEventsService,
    private buttonControlService: ButtonControlService,
  ) {
  }

  ngOnInit(): void {
    this.buttonControlService.cambiarBotonSiguiente(false);
    console.log(this.expediente);
    // this.expediente = this.data?.paso?.inData?.expediente;

    console.debug("solicitud-pago")
    const value = this.expediente?.secciones?.filter((sec: any) => sec.origen === "solicitudPago");
    console.debug(value)
    if(value && value.length > 0 && value[0].propiedades?.tAllOpcionPago?.tAllOpcionPago?.tAllTramiteAPagar?.value){
      console.log(value[0].propiedades?.tAllOpcionPago?.tAllOpcionPago?.tAllTramiteAPagar?.value)
      this.originalUrl = value[0].propiedades?.tAllOpcionPago?.tAllOpcionPago?.tAllTramiteAPagar?.value;
    } else {
      this.withouturl = true;
    }
  }

  openUrl(){
    this.buttonControlService.cambiarBotonSiguiente(true);
    window.open(this.originalUrl);

    const response: EvkSeccionModel = {
      origen: this.config.nombre,
      propiedades: {
        url: this.originalUrl,
      },
    };
    console.debug("Enviando datos a wizard");
    // this.datosSeccionWizard.doneSave(response);
    this.resultObject.next(response);
  }

}
